import React, { FC } from 'react';
import classNames from 'classnames';
import classes from './styles/listLayoutBar.module.scss';

export const ListLayoutBarRow: FC<
	React.PropsWithChildren<{
		className?: string;
	}>
> = ({ children, className }) => {
	const componentClasses = classNames(classes.listPageBarRow, className);
	return <section className={componentClasses}>{children}</section>;
};
